import {Amplify } from "aws-amplify";
import awsconfig from "../amplifyconfiguration.json";

export const isLocalhost = Boolean(
  window.location.hostname === "localhost" ||
    // [::1] is the IPv6 localhost address.
    window.location.hostname === "[::1]" ||
    // 127.0.0.1/8 is considered localhost for IPv4.
    window.location.hostname.match(
      /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
    )
);

// Use the current origin so OAuth works on every deploy target
// (the Stockholm CloudFront URL pre-DNS-flip, dogcontroller.com after,
// and localhost during dev). The Cognito user pool's allowed callback
// URLs must include each origin we want to support.
let redirectSignIn = window.location.origin;
let redirectSignOut = window.location.origin;
let responseType = awsconfig.oauth.responseType;

let awsMobile = {...awsconfig};

// @ts-ignore
awsMobile.Analytics = { disabled: true };
awsMobile.oauth.redirectSignIn = redirectSignIn;
awsMobile.oauth.redirectSignOut = redirectSignOut;
awsMobile.oauth.responseType = responseType;
//@ts-ignore
awsMobile.oauth.scope = undefined;


Amplify.configure(awsMobile);

// Storage.configure({ level: "public" });
// PubSub.configure(awsMobile);
